module.exports = __webpack_public_path__ + "static/scale-model-of-baseball-bat-in-louisville-kentucky-9abf91fa7ad820e52cd2aca8011a7bd2.png";